import type { UserProfileResponse } from "@repo/types";
import { apiClient } from "./base/http";

export const fetchCurrentUser = async () => {
  const { data } = await apiClient.get<UserProfileResponse>("/api/users/profile");
  if (!data.success) {
    throw new Error("無法取得用戶資料");
  }
  return data.user;
};
